import React, { useState } from "react";
import { useAuth } from "../../../../firebase/AuthContext";
import profileDemo from "../docsAssets/openProfile2_demo.mp4";
import changePp from "../docsAssets/changepp_screenshot.png";
import savePp from "../docsAssets/savePp_screenshot.png";

export default function UserManagement({ isEN }) {
  const { currentUser } = useAuth();
  const [previewSrc, setPreviewSrc] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const openPreview = (src) => {
    setPreviewSrc(src);
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
    setPreviewSrc(null);
  };

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
            {/* Header with icon */}
            <div className="bg-gradient-to-r from-orange-500 to-red-500 px-6 py-8 text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">
                {isEN ? "Access Required" : "需要存取權限"}
              </h2>
              <p className="text-orange-100 text-sm">
                {isEN ? "Troubleshooting Guide" : "故障排除指南"}
              </p>
            </div>

            {/* Content */}
            <div className="px-6 py-8">
              <div className="text-center mb-6">
                <h3 className="text-gray-800 dark:text-white font-semibold text-lg mb-3">
                  {isEN ? "Please log in to continue" : "請登入以繼續"}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                  {isEN
                    ? "You need to be authenticated to access the troubleshooting guide and technical support resources."
                    : "您需要進行身份驗證才能存取故障排除指南和技術支援資源。"}
                </p>
              </div>

              {/* Features preview */}
              <div className="space-y-3 mb-8">
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                  {isEN ? "Common issues & solutions" : "常見問題和解決方案"}
                </div>
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  {isEN ? "Step-by-step guides" : "逐步指南"}
                </div>
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  {isEN ? "Direct support contact" : "直接支持聯繫"}
                </div>
              </div>

              {/* Login prompt */}
              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
                <p className="text-center text-gray-700 dark:text-gray-300 text-sm">
                  {isEN
                    ? "Return to the main page to sign in with your account"
                    : "返回主頁面使用您的帳號登入"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center mb-8">
        {/* <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center mr-4 shadow-lg">
                    <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                        />
                    </svg>
                </div> */}
        <div>
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
            {isEN ? "User Management" : "使用者管理"}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-1">
            {isEN
              ? "A guide to managing your user profile and understanding permissions"
              : "管理使用者資料和理解權限的指南"}
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="bg-slate-200 dark:bg-gray-900/40 rounded-lg p-6 border border-gray-600 shadow-lg">
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
              {isEN ? "User Profile & Settings" : "用戶資料和設置"}
            </h3>
          </div>

          <div className="space-y-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-blue-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Managing Your Profile" : "管理您的個人資料"}
                </h4>
              </div>
              <p className="text-gray-700 dark:text-gray-300 text-sm mb-4">
                {isEN
                  ? "Access your profile settings through the user menu in the top navigation bar."
                  : "透過頂部導覽列中的使用者選單存取您的個人資料設定。"}
              </p>
              <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700">
                <video
                  src={profileDemo}
                  className="w-full h-full object-cover"
                  controls
                />
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-gray-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Account Settings" : "帳戶設定"}
                </h4>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <h5 className="text-orange-600 dark:text-orange-400 text-sm font-semibold">
                    {isEN ? "Profile Information:" : "個人資料資訊:"}
                  </h5>
                  <ul className="text-gray-700 dark:text-gray-300 text-sm space-y-1">
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      {isEN ? "Display name" : "顯示名稱"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      {isEN ? "Email address" : "電子郵件地址"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      {isEN ? "Profile picture" : "頭像"}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-purple-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "User Permissions" : "使用者權限"}
                </h4>
              </div>
              <p className="text-gray-700 dark:text-gray-300 text-sm mb-4">
                {isEN
                  ? "Your account has specific permissions based on your role. Contact an administrator to request additional access."
                  : "您的帳戶根據您的角色具有特定權限。聯絡管理員請求額外存取權限。"}
              </p>
              <div className="grid md:grid-cols-3 gap-4">
                <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-lg p-4 text-white shadow-md">
                  <div className="text-green-100 text-xs font-bold mb-2 uppercase tracking-wide">
                    User
                  </div>
                  <ul className="text-green-50 text-sm space-y-1">
                    <li className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-green-200 rounded-full mr-2"></div>
                      {isEN ? "Chat access" : "聊天訪問"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-green-200 rounded-full mr-2"></div>
                      {isEN ? "Profile editing" : "編輯個人資料"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-green-200 rounded-full mr-2"></div>
                      {isEN ? "Basic features" : ""}
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg p-4 text-white shadow-md">
                  <div className="text-yellow-100 text-xs font-bold mb-2 uppercase tracking-wide">
                    Editor
                  </div>
                  <ul className="text-yellow-50 text-sm space-y-1">
                    <li className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-yellow-200 rounded-full mr-2"></div>
                      {isEN ? "All standard features" : "所有標準功能"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-yellow-200 rounded-full mr-2"></div>
                      {isEN ? "Data Edit & Upload" : "數據編輯與上傳"}
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-lg p-4 text-white shadow-md">
                  <div className="text-red-100 text-xs font-bold mb-2 uppercase tracking-wide">
                    ADMIN
                  </div>
                  <ul className="text-red-50 text-sm space-y-1">
                    <li className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-red-200 rounded-full mr-2"></div>
                      {isEN ? "All features" : "所有功能"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-red-200 rounded-full mr-2"></div>
                      {isEN ? "User management" : "使用者管理"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-red-200 rounded-full mr-2"></div>
                      {isEN ? "System settings" : "系統設定"}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-gray-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Change Profile Picture" : "更改頭像"}
                </h4>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="flex items-center rounded-lg overflow-hidden cursor-pointer transform transition-transform hover:scale-105">
                  <img
                    src={changePp}
                    alt="Change profile avatar"
                    className="w-full h-auto object-cover rounded-lg"
                    onClick={() => openPreview(changePp)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") openPreview(changePp);
                    }}
                  />
                </div>
                <div className="space-y-4">
                  <p className="text-gray-700 dark:text-gray-300 text-sm">
                    {isEN
                      ? "To change your profile picture, directly click 'Choose Image' then choose the image from your device."
                      : '若要變更您的個人資料圖片，請直接按一下"選擇圖像"，然後從您的裝置中選取影像。'}
                  </p>
                  <div className="border-l-4 border-cyan-500 pl-4 bg-cyan-50 dark:bg-cyan-900/20 py-2">
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      {isEN
                        ? "After choosing the picture you want, save the changes by clicking 'Upload' or 'Update Profile'"
                        : '選擇您想要的圖片後，透過點擊"儲存"來儲存變更。'}
                    </p>
                  </div>
                  <div className="flex justify-center rounded-lg overflow-hidden  cursor-pointer transform transition-transform hover:scale-105">
                    <img
                      src={savePp}
                      alt="Save profile avatar"
                      className="w-3/4 h-auto object-cover rounded-lg"
                      onClick={() => openPreview(savePp)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") openPreview(savePp);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Image preview modal */}
      {isPreviewOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
          onClick={closePreview}
        >
          <div
            className="relative max-w-4xl max-h-[90vh] p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 text-white bg-black/40 rounded-full w-8 h-8 flex items-center justify-center"
              onClick={closePreview}
              aria-label="Close preview"
            >
              ×
            </button>
            <img
              src={previewSrc}
              alt="Preview"
              className="w-auto max-w-full max-h-[80vh] rounded-md object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
}
